import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { RemoteAccessSolutionBG } from "../../constant";

export default function RemoteAccessLanding() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "50vh", md: "80vh" },
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          minHeight: "-webkit-fill-available",
          zIndex: -1,
          overflow: "hidden",
          pointerEvents: "none",
          background: "black",
          "::after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          },
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            minHeight: "-webkit-fill-available",
            WebkitMask: "radial-gradient(circle at top left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 1) 60%)",
            mask: "radial-gradient(circle at top left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 1) 60%)",
          }}
        >
          <source src={RemoteAccessSolutionBG} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
          padding: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          margin: "0 auto",
          alignItems: "center",
        }}
      >
        {/* Title Box */}
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{
            width: "100%",
            maxWidth: "1200px",
            textAlign: "left",
            py: 4,
            mt: 4,
          }}
        >
          <Grid container spacing={0}>
            <Grid xs={12} sm={12} md={8} lg={8}>
              <Typography
                variant="h2"
                sx={{
                  background: 'linear-gradient(262.41deg, #1DA1F2 -8.32%, #6843EC 93.3%)',
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: { xs: "24px", sm: "32px", md: "48px" },
                  fontWeight: 700,
                  mb: 2,
                  textAlign: "start",
                  letterSpacing: isMobile ? "0px" : "-2.4px",
                  display: "flex",
                  justifyContent: "center",
                  width: '80%'
                }}
              >
                {`Intelligent Monitoring for Remote Industrial Assets`}
              </Typography>
            </Grid>
            <Grid xs={12} sm={12} md={6} lg={6}>
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: { xs: "14px", md: "16px" },
                  lineHeight: 1.8,
                  textAlign: "start",
                  marginTop: 5,
                }}
              >
                {"Monitor, manage, and optimize distributed industrial assets through real-time operational visibility and connected intelligence. At iEnergy, we enable organizations to remotely track equipment health, operational status, energy usage, and critical performance indicators across plants, mines, utilities, and field operations. Our centralized monitoring dashboards combine IoT integration, live analytics, automated alerts, and predictive insights to help reduce downtime, improve asset reliability, strengthen operational control, and support faster decision-making from anywhere."}              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}